import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element, role }) => {
  const superAdminToken =localStorage.getItem("superAdminToken");

    if (role === "super_admin" && superAdminToken) {
        return element;
    }

  // Redirect to login if not authorized
  return <Navigate to="/super-sign-in" />;
};

export default ProtectedRoute;
